import { USER_MANAGEMENT, userHomeHref } from "../../routes";

/** What the Invite screen starts with: the same details a Join request fills in. */
export type InvitePrefill = {
  email?: string;
  phoneNumber?: string;
  alias?: string;
  circleIds?: string[];
};

/** What another page hands Users in router state: a search to run, or an Invite to start. */
export type UsersHandover = { search?: string; invite?: InvitePrefill };

/** Users' router state, read on arrival; anything else is no handover. */
export const readUsersHandover = (state: unknown): UsersHandover => {
  const { search, invite } = (state ?? {}) as UsersHandover;
  return {
    ...(typeof search === "string" && search ? { search } : {}),
    ...(invite && typeof invite === "object" ? { invite } : {}),
  };
};

/** The Users tabs a link can open (`?tab=`). */
export type UsersTab = "invitations" | "requests";

export const usersHref = (tab?: UsersTab) =>
  tab ? `${USER_MANAGEMENT}?tab=${tab}` : USER_MANAGEMENT;

export const toUsers = (handover: UsersHandover, tab?: UsersTab) => ({
  pathname: usersHref(tab),
  state: handover,
});

/** What another page hands a User's page in router state: open Remove straight away. */
export type UserHomeHandover = { remove?: boolean };

/** A User's page's router state, read on arrival; anything else is no handover. */
export const readUserHomeHandover = (state: unknown): UserHomeHandover =>
  (state as UserHomeHandover | null)?.remove === true ? { remove: true } : {};

export const toUserHome = (userId: string, handover: UserHomeHandover = {}) => ({
  pathname: userHomeHref(userId),
  state: handover,
});
